import {
  Chart,
  ChartTypeRegistry,
  ScatterDataPoint,
  BubbleDataPoint,
} from 'chart.js';
import { CHART_CONFIG } from '../../chartConfig';

// $gray-blue-10 — dashed vertical hover line drawn on the canvas (JS value required).
const VERTICAL_HOVER_LINE_COLOR = CHART_CONFIG.verticalHoverLine.color;

export const verticalAnnotation = {
  id: 'tooltipVerticalAnnotation',
  beforeDraw: (
    chart: Chart<
      keyof ChartTypeRegistry,
      (number | ScatterDataPoint | BubbleDataPoint)[],
      unknown
    >
  ): void => {
    const activeEl = chart?.tooltip?.getActiveElements();
    if (activeEl?.length) {
      const { ctx } = chart;
      const activePoint = activeEl[0];

      ctx.save();

      ctx.setLineDash([6, 6]);
      ctx.lineWidth = 1;
      ctx.strokeStyle = VERTICAL_HOVER_LINE_COLOR;
      ctx.beginPath();
      ctx.moveTo(activePoint.element.x, chart.chartArea?.top);
      ctx.lineTo(activePoint.element.x, chart.chartArea?.bottom);
      ctx.stroke();

      ctx.setLineDash([]);
      ctx.restore();
    }
  },
};
